import { useNavigate } from 'react-router-dom'; 
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { toast } from 'react-toastify';

export default function PreloadNav() {
  const navigate = useNavigate();
  const userName = sessionStorage.getItem('userName')
  const role = sessionStorage.getItem('role')

   const goToForm1 = (formName) => {
          
          if (formName === 'form1') {
              const access = sessionStorage.getItem('form1');
              
              if (access === 'true') {
                  navigate('/PreLoadingLogs');
                  toast.success('Welcome to Preloading Logs');
              } else {
                  toast.error('You don\'t have access to Preloading Form, please contact admin');
              }
          }
  
      }   
       
      const goToForm2 = (formName) => {
  
          if (formName === 'form2') {
              const access = sessionStorage.getItem('form2');
              
              if (access === 'true') {
                  navigate('/CostSheetEntLogs');
                  toast.success('Welcome to CostSheet-Ent Logs');
              } else {
                  toast.error('CostSheet-Corp form is in WIP!');
              }
          }
  
  
      }   
       
      const goToForm3 = (formName) => {
      
          if (formName === 'form3') {
              const access = sessionStorage.getItem('form3');
              
              if (access === 'true') {
                  navigate('/home');
                  toast.success('Welcome to CostSheet-Govt Logs');
              } else {
                  toast.error('CostSheet-Govt form is in WIP!');
              }
          }
  
      } 
  
      const goToForm4 = (formName) => {
          
          if (formName === 'form4') {
              const access = sessionStorage.getItem('form4');
              
              if (access === 'true') {
                  navigate('/home');
                  toast.success('Welcome to RE-Approval Logs');
              } else {
                  toast.error('RE-Approval form is in WIP!');
              }
          }
  
      };

  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary" bg="dark" data-bs-theme="dark" >
        <Container>
          <Navbar.Brand onClick={() => navigate('/home')}>HISYS-INDIA</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="">
            <Nav className="me-auto">
              <Nav.Link onClick={() => navigate('/home')}>Home</Nav.Link>
              <NavDropdown title="Logs" id="collapsible-nav-dropdown">
                {sessionStorage.getItem('form1') === 'true' && (<NavDropdown.Item onClick={() => goToForm1('form1')}>Preloading Logs</NavDropdown.Item>)}
                {sessionStorage.getItem('form2') === 'true' && (<NavDropdown.Item onClick={() => goToForm2('form2')}>CostSheet Ent. Logs</NavDropdown.Item>)}
                {sessionStorage.getItem('form3') === 'true' && (<NavDropdown.Item onClick={() => goToForm3('form3')}>CostSheet Govt. Logs</NavDropdown.Item>)}
                {sessionStorage.getItem('form4') === 'true' && (<NavDropdown.Item onClick={() => goToForm4('form4')}>RE-Approvals Logs</NavDropdown.Item>)}
                {/* <NavDropdown.Item onClick={() => goToForm1('form1')}>Preloading Logs</NavDropdown.Item>
                <NavDropdown.Item onClick={() => goToForm2('form2')}>CostSheet Ent. Logs</NavDropdown.Item>
                <NavDropdown.Item onClick={() => goToForm3('form3')}>CostSheet Govt. Logs</NavDropdown.Item>
                <NavDropdown.Item onClick={() => goToForm4('form4')}>RE-Approvals Logs</NavDropdown.Item> */}
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (<NavDropdown.Divider />)}
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || 
                  sessionStorage.getItem('role') === 'ADMIN') && (<NavDropdown.Item onClick={() => navigate('/PreloadingList')}>Preloading List</NavDropdown.Item>)}
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && 
                (<NavDropdown.Item onClick={() => navigate('/CostSheetEntList')}>Ent. CostSheet List</NavDropdown.Item>)}
              </NavDropdown>
               {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (<NavDropdown title="Admin" id="collapsible-nav-dropdown">
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (<NavDropdown.Item onClick={() => navigate('/Admin')}>Admin Pannel</NavDropdown.Item>)}
                {sessionStorage.getItem('role') === 'ADMIN' && (<NavDropdown.Divider />)}
                {sessionStorage.getItem('role') === 'ADMIN' && (<NavDropdown.Item onClick={() => navigate('/CrmDetails')}>Crm Details</NavDropdown.Item>)}
                {sessionStorage.getItem('role') === 'ADMIN' && (<NavDropdown.Item onClick={() => navigate('/SalepersonMaster')}>Saleperson Master</NavDropdown.Item>)}
              </NavDropdown>)}
            </Nav>
              {/* {sessionStorage.getItem('role') === 'ADMIN' && (<Nav.Link onClick={() => navigate('/Admin')}>Admin Pannel</Nav.Link>)} */}
            <Nav>
              <Nav.Item className="text-muted pt-2">Welcome {userName} San</Nav.Item>
              <Nav.Link onClick={() => navigate('/logout')}>| Logout</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>

  );
}